export const csvTypes = {
    'application/csv': ['application/csv'],
    'application/x-csv': ['application/x-csv'],
    'text/csv': ['text/csv'],
    'text/comma-separated-values': ['text/comma-separated-values'],
    'text/x-comma-separated-values': ['text/x-comma-separated-values'],
    'text/tab-separated-values': ['text/tab-separated-values'],
    'application/vnd.ms-excel': ['application/vnd.ms-excel'],
};
